import script from "./UrlCode.vue?vue&type=script&setup=true&lang=js"
export * from "./UrlCode.vue?vue&type=script&setup=true&lang=js"

import "./UrlCode.vue?vue&type=style&index=0&id=85fb5594&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85fb5594"]])

export default __exports__